var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hiw-content flex xl:flex-row lg:flex-row flex-row md:flex-col justify-between items-start"},[_c('HowItWorkLeft'),_c('HowItWorkRight',{attrs:{"img":_vm.hiwimg,"rpimg":_vm.hiwimg2}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }